import React from "react";
import { Table, Tag, Typography } from "antd";
import { DollarOutlined } from "@ant-design/icons";
import THEME from "../theme";
import StyledCard from "../components/StyledCard";
import { formatMoney, formatDate } from "../utils";

const { Text } = Typography;

const DebtDetailTab = ({ judgeData }) => {
  // ตัดดอกเบี้ยก่อนฟ้อง (PAYFOR 444) ออก
  const arothr = (judgeData?.arothr || []).filter(
    (r) => String(r.PAYFOR) !== "444",
  );
  if (!arothr?.length) return null;

  const totalPayAmt = arothr.reduce((sum, r) => sum + Number(r.PAYAMT || 0), 0);
  const totalSmPay = arothr.reduce((sum, r) => sum + Number(r.SMPAY || 0), 0);
  const totalBalance = totalPayAmt - totalSmPay;

  const columns = [
    {
      title: "#",
      key: "index",
      width: 50,
      align: "center",
      render: (_, __, idx) => idx + 1,
    },
    {
      title: "เลขที่ลูกหนี้",
      dataIndex: "ARCONT",
      key: "ARCONT",
      render: (val) => (
        <Text copyable style={{ fontFamily: "monospace", fontSize: 14 }}>
          {val}
        </Text>
      ),
    },
    {
      title: "วันที่ตั้งหนี้",
      dataIndex: "ARDATE",
      key: "ARDATE",
      render: (val) => formatDate(val),
    },
    {
      title: "รายการ",
      dataIndex: "FORDESC",
      key: "FORDESC",
      render: (val, r) => (
        <Text>
          <Tag color="blue">{r.PAYFOR}</Tag>
          {val}
        </Text>
      ),
    },
    {
      title: "ยอดตั้งหนี้",
      dataIndex: "PAYAMT",
      key: "PAYAMT",
      align: "right",
      render: (val) => formatMoney(val),
    },
    {
      title: "ชำระแล้ว",
      dataIndex: "SMPAY",
      key: "SMPAY",
      align: "right",
      render: (val) => (
        <Text style={{ color: THEME.success }}>{formatMoney(val)}</Text>
      ),
    },
    {
      title: "คงเหลือ",
      key: "balance",
      align: "right",
      render: (_, r) => {
        const balance = Number(r.PAYAMT || 0) - Number(r.SMPAY || 0);
        return (
          <Text
            strong
            style={{ color: balance > 0 ? THEME.danger : THEME.success }}
          >
            {formatMoney(balance)}
          </Text>
        );
      },
    },
    {
      title: "วันที่ชำระล่าสุด",
      dataIndex: "PAYDT",
      key: "PAYDT",
      align: "center",
      render: (val) => formatDate(val),
    },
  ];

  return (
    <StyledCard
      title="รายละเอียดหนี้อื่น ๆ"
      icon={<DollarOutlined style={{ color: THEME.primary, fontSize: 18 }} />}
      style={{ marginBottom: 16 }}
    >
      <Table
        dataSource={arothr}
        columns={columns}
        rowKey="ARCONT"
        pagination={false}
        size="small"
        scroll={{ x: "max-content" }}
        summary={() => (
          <Table.Summary.Row style={{ background: THEME.light }}>
            <Table.Summary.Cell index={0} colSpan={4}>
              <Text strong>รวม</Text>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={4} align="right">
              <Text strong>{formatMoney(totalPayAmt)}</Text>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={5} align="right">
              <Text strong style={{ color: THEME.success }}>
                {formatMoney(totalSmPay)}
              </Text>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={6} align="right">
              <Text strong style={{ color: THEME.danger, fontSize: 16 }}>
                {formatMoney(totalBalance)}
              </Text>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={7} />
          </Table.Summary.Row>
        )}
      />
    </StyledCard>
  );
};

export default DebtDetailTab;
